import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Eyebrow } from './Eyebrow';

interface SectionHeadProps {
  eyebrow?: string;
  heading: string;
  body?: string;
  rightSlot?: ReactNode;
}

const Wrap = styled.header`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: ${(p) => p.theme.step[6]}px;
  align-items: end;
  padding: ${(p) => p.theme.step[7]}px 0;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const Heading = styled.h2`
  font-family: ${(p) => p.theme.font.serif};
  font-size: clamp(${(p) => p.theme.step[6]}px, 4vw, ${(p) => p.theme.step[9]}px);
  margin: 12px 0 0;
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: ${(p) => p.theme.color.text[0]};
`;

const Body = styled.p`
  font-size: ${(p) => p.theme.step[5]}px;
  color: ${(p) => p.theme.color.text[1]};
  line-height: 1.5;
  margin: 0;
`;

export function SectionHead({ eyebrow, heading, body, rightSlot }: SectionHeadProps) {
  return (
    <Wrap>
      <div>
        {eyebrow && <Eyebrow $variant="amber">{eyebrow}</Eyebrow>}
        <Heading>{heading}</Heading>
      </div>
      <div>
        {body && <Body>{body}</Body>}
        {rightSlot}
      </div>
    </Wrap>
  );
}
